import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesProducts } from "../../constants/enums";
import { ProductBadge } from "../../product.types";

export const requestProductBadges = async (
  params: GetListRequestParams
): Promise<GetListResponse<ProductBadge>> => {
  return await instance.get(ApiRoutesProducts.ProductBadges, { params });
};
